import View from './View';

export { default as View } from './View';
export * from './types';
export const useViewModel = (props) => props;
export const getOnboardingPageStyles = () => {};

export default View;
